<div class="dialog-container">
  <h2 mat-dialog-title>{{ data.mode === 'create' ? 'Add Remote Client' : 'Edit Remote Client' }}</h2>

  <mat-dialog-content>
    <form class="client-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Client Name</mat-label>
        <input matInput [(ngModel)]="client.name" name="name" required>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Group</mat-label>
        <input matInput [(ngModel)]="client.group" name="group">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>RustDesk ID</mat-label>
        <input matInput [(ngModel)]="client.rustdeskId" name="rustdeskId" required>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>PIN / Password</mat-label>
        <input matInput [(ngModel)]="client.pin" name="pin" type="password">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contact Name</mat-label>
        <input matInput [(ngModel)]="client.contactName" name="contactName">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contact Phone</mat-label>
        <input matInput [(ngModel)]="client.contactPhone" name="contactPhone">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contact Email</mat-label>
        <input matInput [(ngModel)]="client.contactEmail" name="contactEmail" type="email">
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  </mat-dialog-actions>
</div>